import logger from '../common/logger';
const SnapChatEventMappings = {
  'Presell Page': {
    eventName: 'PAGE_VIEW',
  },
  'Listicle Landing': {
    eventName: 'PAGE_VIEW',
  },
  'Splash Page': {
    eventName: 'PAGE_VIEW',
  },
  'Landing Page': {
    eventName: 'PAGE_VIEW',
  },
  'Custom Landing Page': {
    eventName: 'PAGE_VIEW',
  },
  'Select Bundle': {
    eventName: 'ADD_CART',
  },
  'Initiate Checkout': {
    eventName: 'START_CHECKOUT',
  },
  // "Shipping Info": {
  //     eventName: "ViewContent",
  // },
  'Order Conversion': {
    eventName: 'PURCHASE',
  },
};
const module = 'SnapchatTracker';
const SnapchatTracker = {
  pixelConfig: null,
  enabled: false,
  load: (pixelConfig) => {
    try {
      if(!pixelConfig || !pixelConfig?.pixelId){
        return;
      }
      SnapchatTracker.pixelConfig = pixelConfig;
      SnapchatTracker.enabled = true;
      /* eslint-disable */
            (function (e, t, n) {
                if (e.snaptr) return; var a = e.snaptr = function () { a.handleRequest ? a.handleRequest.apply(a, arguments) : a.queue.push(arguments) };
                a.queue = []; var s = 'script'; var r = t.createElement(s); r.async = !0;
                r.src = n; var u = t.getElementsByTagName(s)[0];
                u.parentNode.insertBefore(r, u);
            })(window, document,
                'https://sc-static.net/scevent.min.js');

            snaptr('init', SnapchatTracker.pixelConfig.pixelId);
            /* eslint-enable */
    } catch (e) {
      logger.error('load failed', e, { module });
    }
  },
  trackEvent: (eventProperties) => {
    try {
      if(!SnapchatTracker.enabled){
        return;
      }
      if (window.snaptr) {
        const eventName = eventProperties.eventName;
        if (SnapChatEventMappings?.[eventName]) {
          window.snaptr('track', SnapChatEventMappings[eventName].eventName);

          return { eventName: SnapChatEventMappings[eventName].tiktokEventName, pixelConfig: SnapchatTracker.pixelConfig };
        }
      }
    } catch (e) {
      logger.error('trackEvent failed', e, { module });
    }
  },
  trackConversion: (transaction_id, price, currency) => {
    try {
      if(!SnapchatTracker.enabled){
        return;
      }
      if (window.snaptr) {
        window.snaptr('track', 'PURCHASE', {
          transaction_id,
          price,
          currency
        });
      }
    } catch (e) {
      logger.error('trackConversion failed', e, { module });
    }
  }
};
export default SnapchatTracker;
